import { MyIntegerEnum } from './enum'

export const UnidadeMedida = {
  PORCENTAGEM: MyIntegerEnum.create('%', 'PORCENTAGEM'),
  PH: MyIntegerEnum.create('Unit.', 'PH'),
}
